import { useGetAuthData } from 'src/hooks';

import { getHouseHistory } from 'src/api';
import { useQuery } from '@tanstack/react-query';
import { QueryResponseProps } from 'src/typings/reactQueryResponce';
import { IHouseHistoryItem } from '../typings/house';

export function useGetHouseHistory(id: string|undefined, page: number) {
  const { getJWT } = useGetAuthData();
  const jwt = getJWT();
  return useQuery({
    queryKey: ['houseHistory', id, page],
    queryFn: async (): Promise<QueryResponseProps<IHouseHistoryItem[]> | null> => {
      if (!id) return null;
      const { data } = await getHouseHistory(jwt, id, page);
      return {
        itemsPerPage: data['hydra:itemsPerPage'],
        totalItems: data['hydra:totalItems'],
        hydraView: data['hydra:view'],
        members: data['hydra:member'],
      };
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
  });
}
